import clsx from 'clsx'
import update from 'immutability-helper'
import {mapValues} from 'lodash'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import SettingsIcon from '@mui/icons-material/Settings'

import {createPost} from '../../../../helpers/command'
import ConfigurationDialog from './ConfigurationDialog'

const useStyles = makeStyles(configurationStyles)

export default function AssessmentConfiguration ({className, context}) {

  const [opened, open] = React.useState(false)
  const {translate, quizAssessment: assessment} = context
  const classes = useStyles()

  async function updateAssessmentProperty (property, value) {
    const {quizAssessment: {properties = {}}} = await context.updateState({quizAssessment: {properties: {[property]: {$set: value}}}})
    createPost('quiz', 'updateAssessmentProperties')({id: assessment.id, properties})
  }

  return (
    <Box className={clsx(className, classes.root)}>
      <Box className={classes.button} onClick={() => open(true)}>
        <Box className="icon">
          <SettingsIcon />
        </Box>
        <Box className="label">{translate('configuration')}</Box>
      </Box>
      <ConfigurationDialog
        isOpen={opened}
        onClose={() => open(false)}
        {...{context, updateAssessmentProperty}}
      />
    </Box>)
}


function configurationStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  return {
    root: {
      ...verticalCentering
    },
    button: {
      cursor: 'pointer',
      display: 'flex',
      color: '#69748a',
      "& > div": {
        ...verticalCentering
      },
      "& .icon": {
        fontSize: '15pt',
        marginTop: -2,
        marginRight: 6
      },
      "&:hover": {
        color: '#1d9be5',
        "& .icon": {
          transform: 'scale(1.1)'
        }
      }
    }
  }
}
